import { action, observable } from 'mobx';
import {
  ALERT_INFO,
  CANCEL,
  CONTINUE,
  NOTIFICATIONS_TOASTER_DURATION
} from '../../constants/constants';

export class CommonStore {
  @observable isSpinnerOn = false;

  @observable audioRefs = [];

  @observable notifications = [];

  @observable confirmation = {
    message: '',
  };

  @observable progress = '0%';

  @action showSpinner = () => {
    this.isSpinnerOn = true;
  };

  @action hideSpinner = () => {
    this.isSpinnerOn = false;
  };

  @action addAudioRef = (audioRef) => {
    this.audioRefs.push(audioRef);
  };

  @action updateProgress = (audio) => {
    if (!audio) {
      this.progress = '0%';
      return;
    }

    const { currentTime, duration } = audio;
    const progress = currentTime / duration * 100;

    this.progress = `${progress}%`;
  };

  @action stopOtherAudios = (currentRef) => {
    if (this.audioRefs.length > 0) {
      this.audioRefs.forEach((audioRef) => {
        if (audioRef && audioRef !== currentRef && !audioRef.paused) {
          audioRef.pause();
          audioRef.currentTime = 0; // eslint-disable-line no-param-reassign
        }
      });
    }
  };

  @action show = (message, type = ALERT_INFO) => {
    const interval = setInterval(() => this.hide(), NOTIFICATIONS_TOASTER_DURATION);

    this.notifications.push({
      message,
      type,
      interval,
      id: this.notifications.length + 1
    });
  };

  @action hide = (notification = this.notifications[0]) => {
    clearInterval(notification.interval);
    this.notifications = this.notifications.filter(item => item !== notification);
  };

  @action openConfirmation = (message, onConfirm, onCancel, confirmTitle = CONTINUE, cancelTitle = CANCEL) => {
    this.confirmation = {
      cancelTitle,
      confirmTitle,
      message,
      onCancel,
      onConfirm
    };

  };

  @action closeConfirmation = () => {
    this.confirmation = {
      message: ''
    };
  };

}

export default new CommonStore();



// WEBPACK FOOTER //
// ./src/common/stores/common.store.js